export default __webpack_public_path__ + "static/media/water-access.4effb2c0.svg";